import { Store } from 'redux'
import {
  setDesktopBigSizeAction,
  setDesktopSizeAction,
  setPhoneSizeAction,
  setTabletLandscapeSizeAction,
  setTabletPortraitSizeAction
} from './redux/actions/screenSize'
import { ScreenSize } from './redux/state'

function mediaQueries(): {
  Phone: MediaQueryList;
  TabletPortrait: MediaQueryList;
  TabletLandscape: MediaQueryList;
  Desktop: MediaQueryList;
  DesktopBig: MediaQueryList;
} {
  return {
    [ScreenSize.Phone]: window.matchMedia('(max-width: 765px)'),
    [ScreenSize.TabletPortrait]: window.matchMedia('(min-width: 766px)'),
    [ScreenSize.TabletLandscape]: window.matchMedia('(min-width: 980px)'),
    [ScreenSize.Desktop]: window.matchMedia('(min-width: 1280px)'),
    [ScreenSize.DesktopBig]: window.matchMedia('(min-width: 1880px)'),
  }
}

function getMatchedMedia(): ScreenSize {
  const queries = mediaQueries()
  const keys = Object.keys(queries)
  let size = ScreenSize.TabletPortrait
  keys.forEach((key: ScreenSize) => {
    if (queries[key].matches) {
      size = key
    }
  })

  return size
}

// gets the timing stored on the window object for when the splash
// screen is shown since it is before PerfMetrics exists
function loadTiming(): number {
  const loadTimingKey = 'loadTiming'
  // Unfortunately need to store in the window object and this is the
  // best way to pull it out
  // tslint:disable-next-line:no-any
  return (window as any)[loadTimingKey]
}

function listenForResize<S>(store: Store<S>): void {
  const queries = mediaQueries()
  const mediaQueryLists = Object.values(queries)
  /*
   note for anyone curious here: On each callback
   from the listener, we need to check _all_ the
   sizes for matches. This is to do all of our
   media queries "and up". ex. TabletPortrait and up
  */
  mediaQueryLists.forEach((mediaQuery: MediaQueryList) => {
    mediaQuery.addListener(() => {
      updateScreenSize(store, queries)
    })
  })
}

function updateScreenSize<S>(store: Store<S>, queries: { [key: string]: MediaQueryList }): void {
  if (queries.DesktopBig && queries.DesktopBig.matches) {
    store.dispatch(setDesktopBigSizeAction())
  } else if (queries.Desktop && queries.Desktop.matches) {
    store.dispatch(setDesktopSizeAction())
  } else if (queries.TabletLandscape && queries.TabletLandscape.matches) {
    store.dispatch(setTabletLandscapeSizeAction())
  } else if (queries.TabletPortrait && queries.TabletPortrait.matches) {
    store.dispatch(setTabletPortraitSizeAction())
  } else if (queries.Phone && queries.Phone.matches) {
    store.dispatch(setPhoneSizeAction())
  }
}

function detectScreenSize<S>(store: Store<S>): void {
  const queries = mediaQueries()
  updateScreenSize(store, queries)
}

export const windowObject = {
  listenForResize,
  detectScreenSize,
  getMatchedMedia,
  loadTiming,
}
